<template>
  <div>
    <THeading
      tag="h2"
      :level="3"
      class="mb-6"
    >
      {{ title }}
    </THeading>

    <div class="flex flex-col gap-12 md:gap-16">
      <RvRentalsTopHostCard
        v-for="host in hosts"
        :key="host.OwnerId"
        :host="host"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TopHost } from '~/types/rental-api-aliases'

const props = defineProps<{
  hosts: TopHost[]
  locationTitle: string
}>()

const { t } = useI18n()

const title = computed(() => t('title', { locationTitle: props.locationTitle }))
</script>

<i18n lang="json">
{
  "en": {
    "title": "Top Hosts {locationTitle}"
  },
  "fr": {
    "title": "Meilleurs hôtes {locationTitle}"
  }
}
</i18n>
